import type { ReactNode } from 'react';

export const symbol_measuring_tape: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M540-160H260q-24.75 0-42.37-17.63Q200-195.25 200-220v-280q0-142 99-241t241-99q142 0 241 99t99 241q0 142-99 241t-241 99Zm0-60q116.31 0 198.15-81.78 81.85-81.79 81.85-198Q820-616 738.22-698q-81.79-82-198-82Q424-780 342-698.15 260-616.31 260-500v280h280Zm99-181q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-155.5-42.26q-23.5-23.27-23.5-56.5 0-33.24 23.26-56.74 23.27-23.5 56.5-23.5 33.24 0 56.74 23.26 23.5 23.27 23.5 56.5 0 33.24-23.26 56.74-23.27 23.5-56.5 23.5-33.24 0-56.74-23.26ZM109.82-160Q97-160 88.5-168.63 80-177.25 80-190v-140q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v140q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM540-500Z"
		/>
	</svg>
);
